export const getCriterionSelectionId = (selection) => {
    const value = selection && typeof selection === "object" ? selection.id : selection;
    return value === undefined || value === null ? "" : String(value);
};

export const normalizeCriteriaSelectionForAvailableCriteria = (
    selectedCriteria = [],
    criteria = [],
) => {
    const availableById = new Map(
        (Array.isArray(criteria) ? criteria : [])
            .filter((criterion) => criterion?.id)
            .map((criterion) => [String(criterion.id), criterion])
    );
    const seen = new Set();

    return (Array.isArray(selectedCriteria) ? selectedCriteria : [])
        .map((selection) => {
            const id = getCriterionSelectionId(selection);
            if (!id || !availableById.has(id) || seen.has(id)) return null;
            seen.add(id);
            return {
                id,
                ref: Array.isArray(selection?.ref) ? selection.ref.filter(Boolean) : [],
                criterion: availableById.get(id),
            };
        })
        .filter(Boolean);
};

export const isRiskComparisonCriterion = (criterion) => (
    String(criterion?.criterion_type || "").trim() === "document_comparison"
);

export const isReferenceReviewCriterion = (criterion) => (
    String(criterion?.criterion_type || "").trim() === "reference_review"
);

export const getStandardCriteriaSelections = (normalizedSelection = []) => (
    (Array.isArray(normalizedSelection) ? normalizedSelection : [])
        .filter((selection) => (
            !isRiskComparisonCriterion(selection?.criterion)
            && !isReferenceReviewCriterion(selection?.criterion)
        ))
);

export const getStandardCriteriaCountForSelection = (
    selectedCriteria = [],
    criteria = [],
) => getStandardCriteriaSelections(
    normalizeCriteriaSelectionForAvailableCriteria(selectedCriteria, criteria)
).length;

export const buildCriteriaSelectionDebugEntries = (normalizedSelection = [], language = "fr") => (
    (Array.isArray(normalizedSelection) ? normalizedSelection : []).map(({ id, criterion }) => ({
        id,
        label: criterion?.title || criterion?.name || criterion?.label || "",
        status: criterion?.status || null,
        source: criterion?.visibility_scope || (criterion?.client_id == null ? "SYSTEM" : "CLIENT_SHARED"),
        type: criterion?.criterion_type || null,
        language,
    }))
);
